import axios from 'axios'
import {getDecryptBody, validateOfSign} from '../util/makePostData'
import {handleLoading} from '../util/handleLoading'
import {MessageBox, Message} from 'element-ui'
import store from '@/store/index'
import router from '../router'

// 请求serverConfig文件内容
async function getServerConfig () {
  await axios.get('serverConfig.json').then(res => {
    axios.defaults.baseURL = `${location.origin}/HxPcSmartPark`
    localStorage.setItem('baseUrl', axios.defaults.baseURL)
    let headerTitle = res.data.headerTitle || store.state.headerTitle
    store.commit('setHeaderTitle', headerTitle)
    let schCode = res.data.schCode || store.state.schCode
    store.commit('setSchCode', schCode)
    let showCleanSector = res.data.showCleanSector || store.state.showCleanSector
    store.commit('setShowCleanSector', showCleanSector)
    let supportOutsideCard = res.data.supportOutsideCard || store.state.supportOutsideCard
    store.commit('setSupportOutsideCard', supportOutsideCard)
  })
}

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'http://localhost:8989/HxPcSmartPark' // 使用代理转发
  localStorage.setItem('baseUrl', axios.defaults.baseURL)
} else {
  if (process.env.NODE_ENV === 'debug') {
    axios.defaults.baseURL = 'https://192.168.169.227:8210/HxSmartPark'
  } else {
    if (process.env.NODE_ENV === 'production') {
      getServerConfig()
    }
  }
}
let apiUrl = axios.defaults.baseURL
// localStorage.setItem('baseUrl', apiUrl)

axios.defaults.timeout = 1800000
// axios.defaults.withCredentials = true

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.headers.post['Content-Type'] = 'raw;charset=UTF-8'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.interceptors.request.use(
  config => {
    // handleLoading.showFullScreenLoading()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  config => {
    // handleLoading.tryHideFullScreenLoading()
    return config
  },
  response => {
    // console.log(response)
    // handleLoading.tryHideFullScreenLoading()
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200 || response.status === 1) {
      // console.log(response)
      // if (response.data.retCode === 'B001') {
      //   MessageBox.alert('会话已过期，请重新登录！')
      //   router.push('/login')
      // } else if (response.data.retCode === 'ERROR') {
      //   MessageBox.alert(response.data.retMsg)
      // } else if (response.data.retCode === '0000') {
      //   console.log('retCode:0000')
      // } else {
      //   MessageBox.alert(response.data.retCode)
      // }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    // handleLoading.tryHideFullScreenLoading()
    if (error.response.status) {
      // console.log(error.response.status)
      return Promise.reject(error.response)
    }
  })
export {apiUrl}

export function post (url, appCode, bizCode, params, showType, config = {}, needEncript = false, interfaceCode = '') {
  return new Promise((resolve, reject) => {
    if (showType) {
      handleLoading.showFullScreenLoading()
    }
    if (!axios.defaults.baseURL) {
      axios.defaults.baseURL = localStorage.getItem('baseUrl')
    }
    axios.post(url, params, config).then(res => {
      if (showType) {
        handleLoading.tryHideFullScreenLoading()
      }
      let retCode = ''
      let bizData = ''
      let signValid = true
      if (needEncript) {
        // 解密
        let decryptMsg = getDecryptBody(res.data, interfaceCode, appCode, bizCode)
        retCode = decryptMsg.msg.retCode
        bizData = decryptMsg.msg
        // 验签
        let resSign = decryptMsg.sign
        signValid = validateOfSign(bizData, resSign)
      } else {
        retCode = res.data.msg.retCode
        bizData = res.data.msg
        console.log(bizData)
      }
      if (!signValid) {
        // 验签失败
        resolve({msg: '验签失败'})
        console.log('验签失败')
      }
      if (retCode === 'A001') {
        // MessageBox.alert('您的密码为临时密码，请修改密码后再执行其他操作')
        localStorage.setItem('isTemp', '1')
      } else {
        console.log(store.state.lastRequestFlag)
        if (retCode === 'B001' && store.state.lastRequestFlag) {
          MessageBox.alert('会话已过期，请重新登录！')
          router.push('/login')
        } else {
          if (retCode === 'ERROR') {
            if (store.state.hideError) {
              return
            } else {
              if (bizData.retMsg === '用户名不存在！') {
                store.commit('doorControl/clearPermission')
                store.commit('doorControl/clearPullDownList')
                // store.commit('setHideError', true)
                if (router.app.$route.name !== 'Login') {
                  router.replace('/login')
                }
              } else {
                if (bizData.retMsg === '签名验证失败') {
                  store.commit('doorControl/clearPermission')
                  store.commit('doorControl/clearPullDownList')
                  router.replace('/login')
                }
              }
            }
            if (router.app.$route.name === 'Login') {
              // 当前路由在登录页
              if (!store.state.hideError) {
                // 显示状态为false,显示不同种类的消息提示
                showMessage(showType, bizData.retMsg)
                store.commit('setHideError', true)
              }
            } else {
              // 显示不同种类的消息提示
              showMessage(showType, bizData.retMsg)
            }
            // if (res.data.retMsg !== '用户名不存在！') {
            //   MessageBox.alert(res.data.retMsg)
            // }
          } else {
            if (bizData.retCode === '0000') {
              // console.log('retCode:0000')
            } else {
              // MessageBox.alert(res.data.retCode)
            }
          }
        }
      }
      resolve(bizData)
    }).catch(err => {
      // console.log(err)
      handleLoading.tryHideFullScreenLoading()
      if (router.app.$route.name === 'Login') {
        // 当前路由在登录页
        if (!store.state.hideError) {
          // 显示状态为false
          showMessage(showType, '网络通讯异常')
          store.commit('setHideError', true)
        }
      } else {
        showMessage(showType, '网络通讯异常')
      }
      // MessageBox.alert('网络异常')
      reject(err)
    })
  })
}

function showMessage (msgType, msg) {
  if (msgType === 'Alert') {
    MessageBox.alert(msg)
  } else {
    if (msgType === 'message') {
      Message.error(msg)
    }
  }
}

export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js